import { useState, useEffect, useRef } from "react"

export function Countdown({ countdownDate }) {
    const [timerDays, setTimerDays] = useState("00")
    const [timerHours, setTimerHours] = useState("00")
    const [timerMinutes, setTimerMinutes] = useState("00")
    const [timerSeconds, setTimerSeconds] = useState("00")

    //console.log("RENDER")

    let interval = useRef()

    function pad(number) {
        // add a leading zero if the number is less than 10
        return (number < 10 ? "0" : "") + number;
    }

    function startTimer() {
        interval = setInterval(() => {
            const now = new Date().getTime()
            const distance = countdownDate - now

            const days = Math.floor(distance / (1000 * 60 * 60 * 24))
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)))
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
            const seconds = Math.floor((distance % (1000 * 60)) / 1000)

            if (distance < 0) {
                clearInterval(interval.current)
            }
            else {
                setTimerDays(days)
                setTimerHours(hours)
                setTimerMinutes(minutes)
                setTimerSeconds(seconds)
            }
        }, 1000)
    }

    useEffect(() => {
        startTimer()
        var intervalCurrent = interval.current
        return () => {
            clearInterval(intervalCurrent)
        }
    })

    return (
        <div className="d-flex align-items-center timer">
            <div className="d-flex timer-number">
                <span className="timer-texts">Days</span>
                <h2>{pad(timerDays)}</h2>
            </div>
            
            <h2 className="timer-separator">:</h2>
            
            <div className="d-flex timer-number">
                <span className="timer-texts">Hours</span>
                <h2>{pad(timerHours)}</h2>
            </div>

            <h2 className="timer-separator">:</h2>

            <div className="d-flex timer-number">
                <span className="timer-texts">Minutes</span>
                <h2>{pad(timerMinutes)}</h2>
            </div>
            
            <h2 className="timer-separator">:</h2>

            <div className="d-flex timer-number">
                <span className="timer-texts">Seconds</span>
                <h2>{pad(timerSeconds)}</h2>
            </div>
        </div>
    )
}